import React from 'react'

function EnvRoute(env) {
  // env = 'dev'
  if (env === 'dev'){ return "http://localhost:5000"
  }else{ return "https://townhall-api.onrender.com" }

}

export default EnvRoute